export const semverCompare = (v1:string, v2:string): number => {
  if (v1.startsWith(v2 + '-')) return -1
  if (v2.startsWith(v1 + '-')) return 1
  return v1.localeCompare(v2, undefined, { numeric: true, sensitivity: 'case', caseFirst: 'upper' })
}
